import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    breadCrumbContainer: {
      marginInlineStart: "36px",
      marginBottom: "20px",
    },
    historyPercentage: {
      display: "flex",
      flexDirection: "row",
      gap: "12px",
      alignItems: "center",
      paddingLeft: "36px",
      marginTop: "10px",
    },
    overviewWrapper: {
      display: "grid",
      marginTop: "32px",
      gridTemplateColumns: "1fr",
      gridTemplateRows: "auto",
    },
    tabsSide: {
      gridColumn: "1 / 2",
      gridRow: "1 / 2",
      minWidth: 0,
    },
    titleCustomComponent: {
      fontSize: "16px",
      fontWeight: 600,
      lineHeight: "24px",
      color: theme.palette.text?.white,
    },
  };
});
